import { FC } from 'react';

import { ClockIcon } from '@heroicons/react/outline';

import {
  formatKoreanDate,
  formatKoreanTime,
  formatSendTimeRange,
} from './giftCouponRedeem.utils';

interface SendScheduleCardProps {
  requestedAt: Date;
  expectedSendAt: Date;
}

const SendScheduleCard: FC<SendScheduleCardProps> = ({ requestedAt, expectedSendAt }) => (
  <div className="mt-4 overflow-hidden rounded-xl border border-stone-200 bg-white text-left shadow-sm">
    <div className="border-b border-stone-100 bg-stone-50 px-4 py-3">
      <div className="flex items-center gap-2">
        <ClockIcon className="h-5 w-5 text-stone-500" />
        <span className="text-sm font-bold text-stone-600">발송 안내</span>
      </div>
      <p className="mt-1.5 break-keep text-xs font-medium leading-relaxed text-red-600">
        신청하신 번호로 예상 발송시간에 문자 또는 알림톡으로 기프티콘이 전송될 예정입니다.
      </p>
    </div>
    <div className="divide-y divide-stone-100 px-4">
      <div className="flex items-center justify-between py-3">
        <span className="text-sm font-medium text-stone-600">신청 시각</span>
        <span className="text-sm font-medium text-stone-700">
          {formatKoreanDate(requestedAt)} {formatKoreanTime(requestedAt)}
        </span>
      </div>
      <div className="flex items-center justify-between py-3">
        <span className="text-sm font-medium text-stone-600">
          예상 발송{' '}
          <span className="text-[11px] font-medium text-amber-600">(변동 가능)</span>
        </span>
        <div className="text-right">
          <p className="text-sm font-bold text-stone-800">
            {formatKoreanDate(expectedSendAt)}
          </p>
          <p className="text-sm font-medium text-stone-600">
            {formatSendTimeRange(expectedSendAt)}
          </p>
        </div>
      </div>
    </div>
    <div className="bg-stone-50 px-4 py-2">
      <p className="break-keep text-center text-[11px] leading-relaxed text-orange-600">
        주말·공휴일의 경우 발송일이 변동될 수 있습니다
      </p>
    </div>
  </div>
);

export default SendScheduleCard;
